module.exports = __webpack_public_path__ + "img/组 126@2x(2).988d9a78.png";